/**
 * @deprecated Use `NavbarViewV1` - with FF `CONFIGURABLE_WEB_APP_BANNER` instead.
 * @deprecationReason To support custom navbar and release web app banner feature
 */
export const NavbarView: React.FC = () => {
  return (
    <>
      <img src="/images/logo-black.svg" alt="logo" width={'130'} />
    </>
  );
};
